import { useContext } from 'react';
import { userContext } from '../context';

export const useUser=()=>{
    const {user, setUser} = useContext<any>(userContext);

    return ({user, setUser})
}